import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const GalleryThumbnail = (props) => {
  const {
    backgroundImageFilename,
    className,
    isVideoThumbnail,
    onClickHandler,
  } = props;

  return (
    <React.Fragment>
      {isVideoThumbnail && (
        <div className="position-relative">
          <div
            className={`gallery-thumbnail-item ${className}`}
            style={{ backgroundImage: `url(${backgroundImageFilename})` }}
            onClick={onClickHandler}
            onKeyDown={onClickHandler}
            role="none"
          />
          <FontAwesomeIcon
            className="position-absolute brand-text-white"
            style={{
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
            icon="play-circle"
          />
        </div>
      )}

      {!isVideoThumbnail && (
        <div
          className={`gallery-thumbnail-item ${className}`}
          style={{ backgroundImage: `url(${backgroundImageFilename})` }}
          onClick={onClickHandler}
          onKeyDown={onClickHandler}
          role="none"
        />
      )}
    </React.Fragment>
  );
};

export default GalleryThumbnail;

GalleryThumbnail.propTypes = {
  backgroundImageFilename: PropTypes.string,
  className: PropTypes.string,
  onClickHandler: PropTypes.func,
};

GalleryThumbnail.defaultProps = {
  backgroundImageFilename: "",
  className: "",
  onClickHandler: null,
};
